const paginationEllipsis = "px-2 text-muted-foreground";

const opacity40 = "opacity-40";

export { paginationEllipsis, opacity40 };
